import axios from "axios";

export default axios.create({
    baseURL: "https://9xmmmy8fa2.us-east-1.awsapprunner.com/api", //https://app.ecoraapp.com:8094 //https://n38t26q6og.execute-api.us-east-1.amazonaws.com/dev/api
    headers: {
        "Content-type": "application/json",
        //"Access-Control-Allow-Origin": "*"
    }
});